import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

/**
 * 克制风统计卡片（2026）
 * @param {string} label - 标签文本
 * @param {string|number} value - 数值
 * @param {string} color - 主色调：palette 路径（primary/error…，默认）或 hex 直传（兼容）
 * @param {ReactNode} icon - 图标
 * @param {string} trend - 趋势文本(可选)
 */
export default function StatCard({ label, value, color = 'primary', icon, trend }) {
  const theme = useTheme();
  const mainColor =
    color.split('.').reduce((acc, key) => (acc ? acc[key] : undefined), theme.palette) || color;
  const lightColor = theme.palette[color]
    ? theme.palette[color].light
    : `${color}1A`;

  return (
    <Box
      sx={{
        backgroundColor: 'background.paper',
        borderRadius: 10,
        p: 3,
        height: '100%',
        border: '1px solid',
        borderColor: 'divider',
        borderTop: `3px solid ${mainColor}`,
        transition: 'border-color 0.15s ease',
        '&:hover': { borderColor: 'grey.300' },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
        <Box>
          <Typography variant="body2" sx={{ color: mainColor }} fontWeight={600}>
            {label}
          </Typography>
          <Typography
            variant="h4"
            fontWeight={700}
            sx={{ mt: 0.5, letterSpacing: '-0.02em', fontVariantNumeric: 'tabular-nums' }}
          >
            {value}
          </Typography>
          {trend && (
            <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
              {trend}
            </Typography>
          )}
        </Box>
        {icon && (
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: 8,
              backgroundColor: lightColor,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: mainColor,
            }}
          >
            {icon}
          </Box>
        )}
      </Box>
    </Box>
  );
}
